import Parent from '../views/Parent.vue';
import DasboardDetail from '../views/dashboard-detail/DasboardDetail.vue';

const dasboardDetailRoute = {
  path: '/dashboard-detail',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Dashboard Detail',
        appBarTitle: 'Dashboard Detail',
      },
      component: DasboardDetail,
      name: 'DasboardDetail',
    },
  ],

  meta: {
    title: 'BNI QRIS - Dashboard Detail',
    appBarTitle: 'Dashboard Detail',
  },
  component: Parent,
};

export default dasboardDetailRoute;
